/**
 * Pega duas coordenadas e mostra informações do percurso entre elas, velocidade média
 * tempo gasto, distância percorrida.
 *
 * @author Adalto Junior
 * DATE:
 */

import { actionCreators } from "react/api/actions/alerts";
import { getResourceTo } from "react/utils/utils";

Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.Map = Greenmile.Toolbar.Map || {};

Greenmile.Toolbar.Map.DistanceBetweenCoords = function (toolbarSelector, map, options) {
    const generalFunctions = new Greenmile.Calculos.GeneralFunctions();
    const resources = Monet.I18n;
    this.sourceData = null;

    if (options && options.sourceSessionData) {
        this.sourceData = options.sourceSessionData;
    }

    var formatMaxSpeed = function (maxSpeed) {

        var unitSystem = Monet.Session.User.unitSystem;
        var unitSystemStr = resources.getResourcesByKey("Greenmile.UnitMetrics.kilometersPerHour");
        var result = 0;

        var formatter = new Monet.Format.DISTANCE(maxSpeed);

        if (typeof(maxSpeed) !== "undefined") {
            if (unitSystem === "NON_METRIC") {
                result = formatter.convertKmToMiles().format().getValue();
            } else {
                result = maxSpeed.toFixed(2);
            }
        }

        if (unitSystem === "NON_METRIC") {
            unitSystemStr = resources.getResourcesByKey("Greenmile.UnitMetrics.milesPerHour");
        }

        return result + " " + unitSystemStr;
    };

    this.drawSegment = function (pointA, pointB) {

        var polyline = L.polyline([
            [pointA._latlng.lat, pointA._latlng.lng],
            [pointB._latlng.lat, pointB._latlng.lng]
        ]);

        polyline.kind = "coordDistance";

        polyline.addTo(map);

    };

    this.getContentToPopup = function () {

        var m1, m2, totalSpeed = 0, totalDistance = 0, canCount = false, maxSpeed = 0, totalTime = 0;
        var markers = this.sourceData.measureMarkers;
        var actualMarkers = this.sourceData.equipments[markers[0].target.coordinate.equipmentId].arrows;
        var dateMarkerFirst = Monet.Format.DateTime.parse(markers[0].target.coordinate.date).getTime();
        var dateMarkerLast = Monet.Format.DateTime.parse(markers[1].target.coordinate.date).getTime();
        var actualMarkersCopy = actualMarkers;

        if (dateMarkerFirst > dateMarkerLast) {
            m1 = markers[1];
            m2 = markers[0];
        } else {
            m1 = markers[0];
            m2 = markers[1];
        }

        actualMarkers = [];

        // Isso é feito pois o Array no JS é passado como referência e precisamos de uma cópia dele.
        for (var m in actualMarkersCopy) {
            actualMarkers.push(actualMarkersCopy[m]);
        }

        // Obriga as coordenadas ficarem ordenadas por data no array, independente de como elas tenham
        // vindo do servidor
        actualMarkers.sort(function (a, b) {
            const dateA = Monet.Format.DateTime.parse(a.coordinate.date).getTime();
            const dateB = Monet.Format.DateTime.parse(b.coordinate.date).getTime();
            return (dateA > dateB) ? 1 : -1;
        });

        for (var i = 0, j = actualMarkers.length; i < j; i++) {

            var actualMarker = actualMarkers[i];
            var actualMarkerCoordinate = (actualMarker.coordinate) ? actualMarker.coordinate : null;

            if (canCount) {

                var previousMarker = actualMarkers[i - 1];

                totalDistance += actualMarkers[i]._latlng.distanceTo(previousMarker._latlng);
                totalSpeed += (actualMarkerCoordinate) ? actualMarkerCoordinate.speedKmh : 0;

                if (actualMarkerCoordinate) {

                    if (maxSpeed < actualMarkerCoordinate.speedKmh) {
                        maxSpeed = actualMarkerCoordinate.speedKmh;
                    }

                    var previousCoordDate = Monet.Format.DateTime.parse(previousMarker.coordinate.date).getTime();
                    var actualCoordDate = Monet.Format.DateTime.parse(actualMarker.coordinate.date).getTime();
                    totalTime += actualCoordDate - previousCoordDate;

                }

                this.drawSegment(previousMarker, actualMarker);

            }

            if (actualMarker.idCoordinate === m1.target.idCoordinate) {
                canCount = true;
                maxSpeed = (actualMarker.coordinate ) ? actualMarker.coordinate.speedKmh : 0;
            }

            if (actualMarker.idCoordinate === m2.target.idCoordinate) {
                canCount = false;
            }

        }

        var totalStr = generalFunctions.formatDistanceTotal(totalDistance);
        var totalMaxStr = formatMaxSpeed(maxSpeed);
        var speedStr = generalFunctions.calculateAverageSpeed(totalDistance, totalTime);

        var totalTimeStr = new Monet.Date.GeneralFunctions().convertTimeToHoursMinutesAndSeconds(totalTime);

        totalStr = "<strong>" + Monet.I18n.getResourcesByKey("RouteDetail.ToolBar.coordsDistance.totalDistance") + ": </strong>" + totalStr + "<br />";
        totalStr = totalStr + "<strong>" + Monet.I18n.getResourcesByKey("RouteDetail.ToolBar.coordsDistance.AverageSpeed") + ": </strong>" + speedStr;
        totalStr = totalStr + "<br> <strong>" + Monet.I18n.getResourcesByKey("RouteDetail.ToolBar.coordsDistance.MaxSpeed") + ": </strong> " + totalMaxStr;
        totalStr = totalStr + "<br> <strong>" + Monet.I18n.getResourcesByKey("RouteDetail.ToolBar.coordsDistance.TotalTime") + ": </strong> " + totalTimeStr;

        this.sourceData.measureMarkers = [];

        return totalStr;

    };

    this.closePopups = function () {
        map.coordsDistance = false;
        map.closePopup();

        for (const i in map._layers) {
            const layer = map._layers[i];
            if (layer && layer.kind === "coordDistance") {
                map.removeLayer(layer);
            }
        }
    }

    this.setListenerToFinish = function () {
        const theEnd = (e) => {
            if (e.keyCode === 27) {
                this.closePopups();
            }
        };

        $(toolbarSelector).parent().parent().off("keydown", theEnd);
        $(toolbarSelector).parent().parent().on("keydown", theEnd);
    };


    this.addListeners = function () {
        $(`${toolbarSelector} .dropdownMeasurement .Coordsdistance`).off("click");
        $(`${toolbarSelector} .dropdownMeasurement .Coordsdistance`).on("click", function (map, scope) {
            return function () {
                const tabName = Monet.Utils.GetTabName();
                const tabNameReplaced = tabName.replace(/_.*/, '');

                const mappedScreensToKeys = {
                  'TrackEquipmentMaps': 'trackEquipmentCoords',
                  'RouteDetails': 'routeDetailsCoords'
                };

                const ALERT_KEY = mappedScreensToKeys?.[tabNameReplaced] ?? 'routeDetailsCoords';

                window.globalStore.dispatch(actionCreators.closeAlert({ key: ALERT_KEY }));

                scope.closePopups();

                map.coordsDistance = true;
                map.popupDistance = true;

                window.globalStore.dispatch(actionCreators.openAlert({
                  key: ALERT_KEY,
                  title: getResourceTo('coordinatesAlert.distanceBetweenCoords.title'),
                  description: getResourceTo('coordinatesAlert.distanceBetweenCoords.description')
                }));

                map.off("popupopen");
                map.on("popupopen", function () {
                  if (map.popupDistance) {
                    window.globalStore.dispatch(actionCreators.closeAlert({ key: ALERT_KEY }));
                    map.closePopup();
                  }
                });

                map.on("popupclose", function () {
                  window.globalStore.dispatch(actionCreators.closeAlert({ key: ALERT_KEY }));
                  scope.closePopups();
                });
            };
        }(map, this));

        this.setListenerToFinish();
    };

    this.createMarkerBall = function (arrowMarker) {
        const radius = new Greenmile.Coordinates.GeneralFunctions().getRadiusByZoomLevel(map.getZoom());
        const circle = L.circle([arrowMarker.latlng.lat, arrowMarker.latlng.lng], radius, {
            fillOpacity: 0.8,
            opacity: 0
        });

        circle.kind = "coordDistance";
        circle.addTo(map);
    };

    this.addMarkerToList = function (marker) {

        if (!this.sourceData.measureMarkers) {
            this.sourceData.measureMarkers = [];
        }

        if (this.sourceData.measureMarkers.length === 0) {
            this.sourceData.measureMarkers[0] = marker;
        } else {
            this.sourceData.measureMarkers[1] = marker;
        }

    };

    this.validateMarker = function (arrowMarker) {
        const isArrow = arrowMarker.target.kind.indexOf('ARROW') !== -1;

        if (isArrow && this.sourceData.measureMarkers && this.sourceData.measureMarkers.length === 1) {
            return this.sourceData.measureMarkers[0].target.coordinate.equipmentId === arrowMarker.target.coordinate.equipmentId;
        }

        return isArrow;
    };

    this.markerClickHandler = function (arrowMarker) {
        if (this.sourceData.measureMarkers && this.sourceData.measureMarkers.length === 0) {
            for (var i in map._layers) {
                var layer = map._layers[i];
                if (layer && layer.kind === "coordDistance") {
                    map.removeLayer(layer);
                }
            }
        }

        if (map.coordsDistance && this.validateMarker(arrowMarker)) {

            this.createMarkerBall(arrowMarker);

            this.addMarkerToList(arrowMarker);

            if (this.sourceData.measureMarkers.length === 2) {

                this.sourceData.map.popupDistance = false;

                var label = document.createElement("div");

                L.DomUtil.setPosition(label, this.sourceData.measureMarkers[1].layerPoint || this.sourceData.measureMarkers[1].latlng);

                label.innerHTML = this.getContentToPopup();

                L.popup({ offset: new L.Point(38, 10) })
                    .setLatLng([arrowMarker.target._latlng.lat, arrowMarker.target._latlng.lng])
                    .setContent(label.innerHTML)
                    .openOn(map);

            } else if (this.sourceData) {
                this.sourceData.map.popupDistance = true;
            }

        }

    };

};
